import { useState } from "react";
import { useUpdateAthleteMutation } from "../../../store";
import { authHeaders } from "../../../store/authToken";

export default function MobileManager({athlete}){
  const [editAthlete] = useUpdateAthleteMutation();
  const [pass, setPass] = useState();
  let content;

  const onCreateAccount = async (e) => {
    e.preventDefault();
  
    const email = athlete.email;
    const password = generatePassword(12);
  
    try {
      const res = await fetch('/api/create-user', {
        method: 'POST',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ email, password }),
      });
  
      const data = await res.json();
  
      if (res.ok) {
        setPass(password);
        editAthlete({ id:athlete.id, submitData:{native_user:data.user.id} });
      } else {
        alert('Error: ' + data.error);
      }
    } catch (err) {
      console.error('Unexpected error:', err);
    }
  };

  const onResetPassword = async (e) => {
    e.preventDefault();
    
    const password = generatePassword(12);
  
    try {
      const res = await fetch('/api/reset-password', {
        method: 'POST',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ userId: athlete.native_user, email: athlete.email, newPassword: password }),
      });
  
      const data = await res.json();
  
      if (res.ok) {
        setPass(password);
      } else {
        alert('Error: ' + data.error);
      }
    } catch (err) {
      console.error('Unexpected error:', err);
    }
  };
  
  let showPassword;
  if(pass){
    showPassword= <>
      <p className="mt-1 text-sm leading-6 text-gray-600">
        Password: {pass}
      </p>
    </>
  }

  if(athlete.native_user){
    content = <>
      <div className="border-t border-b border-gray-900/10 mt-12 pt-12 pb-12">
        <h2 className="text-base font-semibold leading-7 text-gray-900">Mobile app account management</h2>
        <p className="mt-1 text-sm leading-6 text-gray-600">
          <button onClick={(e)=>{onResetPassword(e)}}
            type="button"
            className="rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Reset Password
          </button>
        </p>
        {showPassword}
      </div>
    </>;
    content = <></> // Comentado porque como ahora va por magic link, no es necesario
  }else{
    content = <>
      <div className="border-t border-b border-gray-900/10 mt-12 pt-12 pb-12">
        <h2 className="text-base font-semibold leading-7 text-gray-900">Mobile app account management</h2>
        <p className="mt-1 text-sm leading-6 text-gray-600">
          <button onClick={(e)=>{onCreateAccount(e)}}
            type="button"
            className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Create account in mobile app
          </button>
        </p>
      </div>
    </>
  }
  return (<>
     {content}
    </>
  );
}


function generatePassword(length = 10) {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let password = '';
  for (let i = 0; i < length; i++) {
    const rand = Math.floor(Math.random() * chars.length);
    password += chars[rand];
  }
  return password;
}